import { createStore, applyMiddleware, compose } from 'redux';
// Imports: Redux
import rootReducer from './reducers';
import { apiMiddleware } from './middlewares';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// 🔐 Persist config
const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['user', 'staff', 'settings', 'controlCenter', 'lead'], // only persist auth slice
};

// Wrap reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);
const saveToLocalStorage = (state) => {
    try {
        // console.log('saveToLocalStorage', state);
        localStorage.setItem(
            'state',
            window.btoa(unescape(encodeURIComponent(JSON.stringify(state)))),
        );
    } catch (e) {
        console.error(e);
    }
};

const loadFromLocalStorage = () => {
    try {
        if (localStorage.hasOwnProperty('state')) {
            const stateStr = window.atob(localStorage.getItem('state'));
            // console.log('loadFromLocalStorage', stateStr);
            return stateStr ? JSON.parse(stateStr) : undefined;
        }
    } catch (e) {
        console.error(e);
        return undefined;
    }
};

const persistedStore = loadFromLocalStorage();

const middlewares = [apiMiddleware];

// if (__DEV__) {
//     // middlewares.push(createLogger());
// }

// Redux: Store
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
    persistedReducer,
    composeEnhancers(applyMiddleware(apiMiddleware)),
);

export const persistor = persistStore(store);

store.subscribe(() => {
    //saveToLocalStorage(store.getState());
});

// Exports
export default store;
